/** @format */

/**
 * KPI list-filter: hide whole projects that don't have the selected KPI; `'all'` keeps everything.
 * `kpiFilter` is a chartId (the header dropdown emits chartIds — the same namespace as
 * `ProjectCardModel.kpiIds`). Filtering happens at the project-list level, NOT inside a card:
 * a matching project still shows ALL its KPI rows.
 */
export const filterProjectsByKpi = <T extends {kpiIds: string[]}>(
  cards: T[],
  kpiFilter: string,
): T[] =>
  kpiFilter === 'all'
    ? cards
    : cards.filter(card => card.kpiIds.some(id => id.toLowerCase() === kpiFilter.toLowerCase()));
